// Radar of the subdimensions (review V2 point 8), drawn before the gauges on the panel. Same geometry as the PDF
// (shared/maturity/radar.ts); vertices carry a native tooltip and the table beside it is the text view.
import { GAUGE_TRACK } from "../../../shared/maturity/gauge.ts";
import { RADAR_STYLE, radarModel, type RadarAxis, type RadarPoint } from "../../../shared/maturity/radar.ts";

const pts = (p: RadarPoint[]) => p.map((q) => `${q.x},${q.y}`).join(" ");
const pctText = (v: number | null) => (v === null ? "pendente" : `${v.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}%`);

export function RadarChart({ axes, showDiagnosis, showPrognosis, label }: { axes: RadarAxis[]; showDiagnosis: boolean; showPrognosis: boolean; label: string }) {
  const m = radarModel(axes);
  const series = (key: "diagnosis" | "prognosis", name: string) => {
    const s = m[key];
    const st = RADAR_STYLE[key];
    return (
      <g data-series={key}>
        {s.closed && (
          <polygon points={pts(s.points as RadarPoint[])} fill={st.color} fillOpacity={st.fill} stroke={st.color} strokeWidth={2} strokeLinejoin="round"
            strokeDasharray={st.dash || undefined} />
        )}
        {s.points.map((p, i) => p && (
          <circle key={i} cx={p.x} cy={p.y} r={4} fill={st.color} stroke="#fff" strokeWidth={1.5}>
            <title>{`${axes[i]!.title} · ${name}: ${pctText(axes[i]![key])}`}</title>
          </circle>
        ))}
      </g>
    );
  };
  return (
    <svg viewBox={`0 0 ${m.width} ${m.height}`} role="img" aria-label={label} className="h-auto w-full max-w-[420px]">
      {m.rings.map((g) => <polygon key={g.value} points={pts(g.points)} fill="none" stroke={GAUGE_TRACK} strokeWidth={g.value === 100 ? 1.2 : 0.8} />)}
      {m.spokes.map((s) => <line key={s.code} x1={m.cx} y1={m.cy} x2={s.end.x} y2={s.end.y} stroke={GAUGE_TRACK} strokeWidth={0.8} />)}
      {m.rings.map((g) => <text key={g.value} x={m.cx + 3} y={g.points[0]!.y + 3} fontSize={7} fill="#66788F" className="num">{g.value}</text>)}
      {showPrognosis && series("prognosis", "Prognóstico")}
      {showDiagnosis && series("diagnosis", "Diagnóstico")}
      {m.spokes.map((s) => (
        <text key={s.code} x={s.label.x} y={s.label.y} textAnchor={s.anchor} fontSize={10} fontWeight={700} fill="#13253D">
          {s.code}<title>{s.title}</title>
        </text>
      ))}
    </svg>
  );
}
